<template>
    <div class="page">
        <el-form :inline="true" ref="cardDetailsForm" @submit.native.prevent :rules="cardDetailsRules" :model="cardDetailsForm" >
            <el-form-item prop="iccid">
                <el-input v-model="cardDetailsForm.iccid"  @keyup.enter.native="getSimDetailInfoHandler"  placeholder="请输入卡号" v-focus clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" plain  icon="el-icon-search" @click="getSimDetailInfoHandler">搜索</el-button>
                <el-button @click="updateStateHandler(cardInfo.iccid, true)">更新</el-button>
            </el-form-item>
        </el-form>  
        <template v-if="showDetail">
            <div class="cerd">
                <div class="cerd-title">卡板信息</div>
                <el-row :gutter="20">
                    <el-col :span="4">
                        <div class="grid-content bg-purple">
                            <div class="name">卡号</div>
                            <div class="content">{{ cardInfo.iccid }}</div>
                        </div>
                    </el-col>
                      <!-- <el-col :span="4">
                        <div class="grid-content bg-purple">
                            <div class="name">接入号</div>
                            <div class="content">{{ cardInfo.intoNo }}</div>
                        </div>
                    </el-col> -->
                      <el-col :span="4">
                        <div class="grid-content bg-purple">
                            <div class="name">虚拟号</div>
                            <div class="content">{{ cardInfo.virtualNo }}</div>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="grid-content bg-purple">
                            <div class="name">通道</div>
                            <div class="content">{{ cardInfo.alias }}</div>
                        </div>
                    </el-col>
                  
                    <el-col :span="4">
                        <div class="grid-content bg-purple">
                            <div class="name">套餐系列</div>
                            <div class="content">{{ cardInfo.basePkgGroupName }}</div>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="grid-content bg-purple">
                            <div class="name">超流量</div>
                            <div class="content">{{ fluxMtoG(cardInfo.outData) }} /GB</div>
                        </div>
                    </el-col>
                  

                    <el-col :span="4">
                        <div class="grid-content bg-purple">
                            <div class="name">卡状态</div>
                            <div class="content" style="color: red;" v-if="cardInfo.supplierName&&cardInfo.supplierName.indexOf('运城')==0 && cardInfo.cardState == 11">  {{ cardInfo.cardStateName }}</div>
                            <div class="content" v-else> 
                                <span class="font-defined dark" v-if="cardInfo.cardState == 1"> {{ cardInfo.cardStateName }}</span>
                                <span class="font-defined green" v-else-if="cardInfo.cardState == 2">{{ cardInfo.cardStateName }}</span>
                                <span class="font-defined red" v-else-if="cardInfo.cardState == 4"> {{ cardInfo.cardStateName }}</span>
                                <span class="font-defined" v-else> {{ cardInfo.cardStateName }}</span>    
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>  

            <div class="cerd">
                <div class="cerd-title">可用套餐</div>
                <div class="package" :style="{'height':isShow ? 'auto' : cardInfo.simPackageList.length > 2 ? '400px' : 'auto'}" style="overflow: hidden;">
                    <div class="total-page" v-for="item in cardInfo.simPackageList" :key="item.id">
                        <div class="total-page-right">
                            <div class="total-page-right-top">
                                <div class="progress">
                                    <el-progress :stroke-width="10" :percentage="item.usedFlowRate/item.flowRate *100" :show-text="false"  type="circle" ></el-progress>
                                    <div class="shengyu">
                                        <div class="name">剩余</div>
                                        <div class="num">{{ decrease(fluxMtoG(item.flowRate) , fluxMtoG(item.usedFlowRate)) }}G</div>
                                    </div>
                                </div>
                                <div class="total-dingdan">
                                    <div class="name">总流量</div>
                                    <div class="num">{{ fluxMtoG(item.flowRate) }}G</div>
                                </div>
                                <div class="total-dingdan" style="padding-left:0;">
                                    <div class="name">订单号</div>
                                    <div class="num">{{ item.id }}</div>
                                </div>
                                <div class="total-dingdan" style="padding-left:100px;">
                                    <div class="name">套餐名称</div>
                                    <div class="num">{{ item.packageName }}</div>
                                </div>
                                <!-- <div class="total-dingdan">
                                    <div class="name">流量百分比</div>
                                    <div class="num">{{ item.flowRatePercent }} %</div>
                                </div> -->
                            </div>
                            <div class="total-page-right-bottom">
                                <div>生效时间：{{ item.startTime }}</div>
                                <div>过期时间：<span :style="{'color':isExpiredTime(item.endTime) ? 'red' : '' }">{{ item.endTime }}</span></div>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="total-page">
                        <div class="total-page-left">
                            <div class="total-used">本月已用流量</div>
                            <div class="total-used-num">42.08G</div>
                        </div>
                        <div class="total-page-right">
                            <div class="total-page-right-top">
                                <div class="progress">
                                    <el-progress :stroke-width="10" :color="'#44D7B6'" :percentage="80" :show-text="false"  type="circle" ></el-progress>
                                    <div class="shengyu">
                                        <div class="name">剩余</div>
                                        <div class="num">100G</div>
                                    </div>
                                </div>
                                <div class="total-dingdan">
                                    <div class="name">总流量</div>
                                    <div class="num">100G</div>
                                </div>
                                <div class="total-dingdan">
                                    <div class="name">订单号</div>
                                    <div class="num">100G</div>
                                </div>
                                <div class="total-dingdan">
                                    <div class="name">套餐名称</div>
                                    <div class="num">100G</div>
                                </div>
                                <div class="total-dingdan">
                                    <div class="name">流量百分比</div>
                                    <div class="num">100G</div>
                                </div>
                                <div class="total-dingdan"></div>
                            </div>
                            <div class="total-page-right-bottom">
                                <div>生效时间：2023.04.23 12:34</div>
                                <div>过期时间：2023.04.23 12:34</div>
                            </div>
                        </div>
                    </div> -->
                </div>
                <div style="display: flex;justify-content: center;" v-if="cardInfo.simPackageList.length > 2"> <el-button @click="isShow = !isShow" type="primary" plain>{{isShow ? '收起' : '展开'}} <i class="el-icon-d-arrow-right el-icon--right"></i></el-button></div>
            </div>

            <div class="cerd">
                <div class="cerd-title">操作管理</div>
                <div class="cerd-btn">
                    <el-button size="normal" @click="simDiagnosisHandler" plain icon="el-icon-s-ticket">刷新复机</el-button>
                    <el-button size="normal" @click="noBIndSIm" plain icon="el-icon-s-ticket">机卡解绑</el-button>
                    <el-button size="normal" @click="stopSimHandler" plain icon="el-icon-s-ticket">智能停机</el-button> 
                    <el-button size="normal" @click="resetSimHandler" plain icon="el-icon-s-ticket">智能复机</el-button>
                    <el-button size="normal" @click="showAddRealNameSearch" plain icon="el-icon-search">实名查询 </el-button>
                </div>
            </div>
            <div class="cerd">
                <div class="cerd-title">往期订单</div>
                <el-table :data="tableData" border>
                    <el-table-column prop="orderNo" label="订单号" align="center"></el-table-column> 
                    <el-table-column prop="packageName" label="套餐名称" align="center"></el-table-column> 
                    <el-table-column prop="packageTypeName"  label="套餐类型" align="center"></el-table-column> 
                    <el-table-column label="套餐流量"  align="center">
                        <template slot-scope="scope">
                            <span>{{ fluxMtoG(scope.row.flowRate) }}G</span>
                        </template>
                    </el-table-column> 
                    <el-table-column prop="createTime" label="订购时间" align="center"></el-table-column> 
                    <el-table-column prop="createTypeName"  label="订购类型" align="center"></el-table-column> 
                    <el-table-column prop="isNextMonthName"   label="生效时间" align="center"></el-table-column> 
                    <!-- <el-table-column label="备注" align="center">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.remark" clearable @blur="modifyOrderInfoHandler(scope.row)"></el-input>
                        </template>    
                    </el-table-column>  -->
                </el-table>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[15, 50, 100, 500]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination> 
            </div>
        </template>   
        
        <el-dialog :append-to-body="true"  title="修改过期时间" :visible.sync="endTimeVisible" width="600px" @close="endTimecancel" :close-on-click-modal="false">
            <el-form ref="endTimeForm" :model="endTimeForm" label-width="120px">
                <el-form-item label="修改方式：" prop="type">
                    <el-select v-model="endTimeForm.type">
                        <el-option value="1" label="指定过期时间">指定过期时间</el-option>
                        <el-option value="2" label="指定延长天数"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="原过期时间：">
                    <div>{{ endTimeForm.oldTimeString }}</div>
                </el-form-item>
                  <el-form-item v-if="endTimeForm.type == 1" label="新开始时间：" prop="newTimeString">
                    <el-date-picker v-model="endTimeForm.newEndString" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>  
                <el-form-item v-if="endTimeForm.type == 1" label="新过期时间：" prop="newTimeString">
                    <el-date-picker v-model="endTimeForm.newTimeString" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>                
                <el-form-item v-else label="延长天数：" prop="dayNum">
                    <el-input v-model="endTimeForm.dayNum" placeholder="请输入天数" clearable></el-input>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input type="textarea" v-model="endTimeForm.remark"  clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="endTimecancel">取 消</el-button>
                <el-button type="primary" @click="sureChangePkgEndTimeHandler">确 定</el-button>
            </div> 
        </el-dialog>
        <el-dialog :append-to-body="true"  title="修改流量信息" :visible.sync="endTimeVisible1" width="600px" @close="endTimecancel1" :close-on-click-modal="false">
            <el-form ref="endTimeForm" :model="endTimeForm" label-width="120px">
               
                <el-form-item label="已使用流量：" prop="use">
                   <el-col style="flex:7">
                        <el-input-number :min="0" v-model="endTimeForm.use" clearable></el-input-number> GB
                    </el-col>
                </el-form-item>
                 <el-form-item label="总流量：" prop="total">
                   <el-col style="flex:7">
                        <el-input-number :min="0" v-model="endTimeForm.total" clearable></el-input-number>GB
                    </el-col>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="endTimecancel1">取 消</el-button>
                <el-button type="primary" @click="sureChangePkgEndTimeHandler1">确 定</el-button>
            </div> 
        </el-dialog>
        <el-dialog :append-to-body="true"  title="新增套餐" :visible.sync="addPkgVisible" width="600px" @close="addPkgCancel" :close-on-click-modal="false">
            <el-form ref="addPkgForm" :model="addPkgForm" :rules="addPkgRules" label-width="130px">
                <el-form-item label="套餐名称：" prop="packageId">
                    <el-radio-group v-model="addPkgForm.packageId" class="pkgName" 
                    @change="changeAddPkgFormItem">
                        <el-radio v-for="item in pkgList" :key="item.id" :label="item.id" style="padding: 10px 0;"> 
                            {{ item.name }}
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="生效时间：" prop="isNextMonth" v-if="addPkgFormIsNextMonth">
                    <el-select v-model="addPkgForm.isNextMonth" >
                        <el-option value="0" label="本月生效">本月生效</el-option>
                        <el-option value="1" label="次月生效">次月生效</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="购买上游套餐：" prop="toBuy">
                    <el-radio-group v-model="addPkgForm.toBuy">
                        <el-radio :label="2">否</el-radio>
                        <el-radio :label="1">是</el-radio>
                    </el-radio-group>
                </el-form-item>          
                <el-form-item label="备注：" prop="remark">
                    <el-input type="textarea" v-model="addPkgForm.remark" placeholder="请输入内容"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addPkgCancel">取 消</el-button>
                <el-button type="primary" @click="sureAddPkgHandle">确 定</el-button>
            </div> 
        </el-dialog> 
        
        <!-- 订单详情 -->
        <el-dialog :append-to-body="true"  title="订单详情" :visible.sync="orderDetailVisible" width="600px" :close-on-click-modal="false">
            <div class="lineInDialog">
                <label>订单号：</label>
                <span>{{orderDetailForm.orderNo}}</span>
            </div>
 
            <div class="lineInDialog">
                <label>套餐名称：</label>
                <span>{{orderDetailForm.packageName}}</span>
            </div>
            <div class="lineInDialog">
                <label>下单金额：</label>
                <span>{{orderDetailForm.priceRmb}} 元</span>
            </div>
 
            <div class="lineInDialog">
                <label>下单时间：</label>
                <span>{{orderDetailForm.createTime}}</span>
            </div>

            <div class="lineInDialog">
                <label>备注：</label>
                <div v-html="orderDetailForm.remark">
                </div>
                
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="orderDetailVisible = false">确 定</el-button>
            </span>            
        </el-dialog>

        <el-dialog :append-to-body="true"  title="添加叠加包" :visible.sync="overlayPkgVisible" width="600px" @close="overlayPkgCancel" :close-on-click-modal="false">
            <el-form ref="overlayPkgForm" :model="overlayPkgForm" :rules="overlayPkgRules" label-width="100px">
                <el-form-item label="套餐组：" prop="typeGroupId">
                    <el-select v-model="overlayPkgForm.typeGroupId" @change="changeHandler" filterable>
                        <el-option v-for="item in overlayPkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
                    </el-select> 
                </el-form-item>
                <el-form-item label="套餐名称：" prop="packageId">
                    <el-select v-model="overlayPkgForm.packageId" clearable>
                        <el-option v-for="item in overlayPkgList" :value="item.id" :key="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="生效时间：" prop="isNextMonth">
                    <el-select v-model="overlayPkgForm.isNextMonth" clearable>
                        <el-option value=0 label="本月生效"></el-option>
                        <el-option value=1 label="次月生效"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="overlayPkgForm.remark" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="overlayPkgCancel">取 消</el-button>
                <el-button type="primary" @click="sureAddOverlayPkg">确 定</el-button>
            </div> 
        </el-dialog>
    </div>
</template>
<script>
import {getSimDetailInfo, getOneSIMOrderList, addPkg, getPkgList, getAllowChangePkgGroup, toChangePkgGroup, changePkgEndTime, 
delayPkgEndTime, delayPkgEndTime1,toNewCard, simDiagnosis, updateState, stopSim, resetSim, getFluxDetailList,
 getSimStopStartRecordList, changeCardState, getOverlayPkgOptions, getRealName,getSimStopStartRecordList1} from '@/api/sim.js'
import {modifyOrderRemark} from '@/api/order.js'
import common from '@/utils/common.js'
import Echarts2 from './compontents/Echarts2'
import '@/styles/txt.wav.css'
export default {
    components:{
        Echarts2
    },
    data(){
        return {
            cardDetailsForm: {
                iccid: ''
            },
            isShow:false,
            showDetail: false,
            cardInfo: {
                outData:'',
                id: '',
                virtualNo:'',
                supplierTypeCode: '',
                iccid: '',
                priceName:'',
                simAmount:'',
                supplierName: '',
                alias: '',
                cardTypeName: '',
                endTime: '',
                intoNo: '',
                cardState:'',
                flowRatePool: '',
                basePkgGroupName: '',
                cardStateName: '',
                flowRatePercent:null,
                simPackageList: [],
                monthTotal:null,
                changeStateRemark: "",
            },
            tableData: [],
            currentPage: 1,
            pageSize: 15,
            total: 0,
            addPkgVisible: false,       //添加套餐
            pkgList: [],
            addPkgForm: {
                isNextMonth: '0',
                packageId: '',
                toBuy: 1,
                remark: ''
            },
            addPkgFormIsNextMonth:false,
            toNewCardVisible: false,    //转新卡
            stateRecordVisible: false,  //停复机记录
            endTimeVisible1: false, //修改流量信息
            endTimeVisible: false,     //修改过期时间
            endTimeForm: {          
                type: '1',
                pkgId: '',
                oldTimeString: '',
                newTimeString: '',
                dayNum: 0,
                remark: '',
                total:'',
                use:'',
                newEndString:''
            },
            allowPkgGroup: [],
            changeStateVisible: false,    //变更卡状态
            cardStateOption:[],
            overlayPkgVisible: false,
            overlayPkgForm: {
                typeGroupId: '',
                packageId: '',
                isNextMonth: '',
                remark: ''
            },
            overlayPkgGroup: [],
            overlayPkgList: [],
            cardDetailsRules: {
                iccid: [{required: true, message: '请输入ICCID号或接入号', trigger: ['change','blur']}]
            },
            addPkgRules: {
                packageId: [{required: true, message: '请选择要充值的套餐', trigger: 'blur'}],
                toBuy: [{required: true, message: '请选择', trigger: 'change'}]
            },
            toNewCardRules:{
                iccid: [{required: true, validator: this.checkIccid, trigger: 'change'}]
            },
            changeStateRules: {
                state: [{required: true, message: '请选择变更状态', trigger: 'blur'}],
                remark: [{required: true, message: '请选择输入变更原因', trigger: 'blur'}],
            },
            overlayPkgRules: {
                
            },
            orderDetailVisible:false,
            orderDetailForm: {},
        }
    },
    mounted () {
        var fromPage = this.$store.state.menu.fromPage;
        var fromPageIccid = this.$store.state.menu.fromPageIccid;
        if(fromPage == 'cardList'){
            this.cardDetailsForm.iccid = fromPageIccid;
            this.getSimDetailInfoHandler(this.cardDetailsForm.iccid);
            this.$store.commit('menu/setFromPage', '');
            this.$store.commit('menu/setFromPageIccid', '');
        }        
    },
    // 指令
    directives: {
        focus: {
            inserted: function (el) {
                function getFocus(element){
                    if(element.nodeName === 'INPUT'){
                        element.focus();
                    }else if(element.children.length > 0){
                        for(let i=0; i<element.children.length; i++){
                            getFocus(element.children[i])
                            return;
                        }
                    }
                }
                getFocus(el);
            }
        }
    },
    methods:{
        getSimDetailInfoHandler(){
            this.$refs.cardDetailsForm.validate( valid => {
                if(valid){            
                    getSimDetailInfo({iccid:this.cardDetailsForm.iccid}).then(res => {
                        if(res.data.code === '200'){
                            this.showDetail = true;
                            var result = res.data;
                            for(var key in this.cardInfo){
                                this.cardInfo[key] = result.data[key];
                            }
                            this.$nextTick(() => {
                                this.updateStateHandler(this.cardDetailsForm.iccid, false);
                                this.showDetail = true;
                            })
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })
                }
            })
            this.getOneSIMOrderListHandler(); 
        },
        updateStateHandler(iccid, showSuccessMsg){
            var data = { iccid };
            updateState(data).then(res => {
                if(res.data.code === '200'){
                    if(showSuccessMsg){
                        this.$message.success(res.data.message);
                    }
                    getSimDetailInfo(data).then(child => {
                        if(child.data.code === '200'){
                            this.showDetail = true;
                            var result = child.data;
                            for(var key in this.cardInfo){
                                this.cardInfo[key] = child.data.data[key];
                            }
                        }
                    });
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        addPkgCancel(){
            this.addPkgVisible = false;
            this.$refs.addPkgForm.resetFields();
        },
        endTimecancel(){
            this.endTimeVisible = false;
            this.$refs.endTimeForm.resetFields();
        },
         endTimecancel1(){
            this.endTimeVisible1 = false;
            this.$refs.endTimeForm.resetFields();
        },
        overlayPkgCancel(){
            this.overlayPkgVisible = false;
            this.$refs.overlayPkgForm.resetFields();            
        },
        getOneSIMOrderListHandler(){
            var data = {
                perPageNum: this.pageSize,
                pageNo: this.currentPage,                
                iccid: this.cardDetailsForm.iccid
            }
            getOneSIMOrderList(data).then(res => {  //获取往期来往订单
                if(res.data.code === '200'){
                    var result = res.data.data;
                    this.tableData = result.resultList;
                    this.total = result.totalNum;
                    this.currentPage = result.pageNo;
                    this.pageSize = result.perPageNum;                     
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        sureChangePkgEndTimeHandler(){
            if(this.endTimeForm.type == 1){
                var data = {
                    simPkgId: this.endTimeForm.pkgId,
                    newTimeString: this.endTimeForm.newTimeString,
                    remark: this.endTimeForm.remark ,
                    newEndString:this.endTimeForm.newEndString           
                }
                changePkgEndTime(data).then(res => {
                    if(res.data.code == 200){
                        this.endTimeVisible = false;
                        this.$message.success('变更过期时间完成！');
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    }else if(res.data.code == 400){
                        this.$message.error(res.data.message);
                    }
                })            
            }else{
                var dataP = {
                    simPkgId: this.endTimeForm.pkgId,
                    dayNum: this.endTimeForm.dayNum,
                    remark: this.endTimeForm.remark   
                }
                delayPkgEndTime(dataP).then(res => {
                    if(res.data.code == 200){
                        this.endTimeVisible = false;
                        this.$message.success('变更过期时间完成！');
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    }else if(res.data.code == 400){
                        this.$message.error(res.data.message);
                    }
                })                
            }
        },
         sureChangePkgEndTimeHandler1(){
            var dataP = {
                id: this.endTimeForm.pkgId,
                flowRate: this.endTimeForm.total,
                usedFlowRate: this.endTimeForm.use   
            }
            delayPkgEndTime1(dataP).then(res => {
                if(res.data.code == 200){
                    this.endTimeVisible1 = false;
                    this.$message.success('修改流量信息完成！');
                    this.getSimDetailInfoHandler(this.cardInfo.iccid);
                }else if(res.data.code == 400){
                    this.$message.error(res.data.message);
                }
            })                
           
        },
        changeAddPkgFormItem(value){
            for(let i=0; i<this.pkgList.length; i++){
                if(value==this.pkgList[i].id){
                    this.addPkgFormIsNextMonth = this.pkgList[i].type == 2||this.pkgList[i].type == 10||this.pkgList[i].type == 14||this.pkgList[i].type == 6||this.pkgList[i].type == 17
                    ||this.pkgList[i].type == 25;
                }
            }
        },
        sureAddPkgHandle(){
            this.$refs.addPkgForm.validate(valid => {
                if(valid){
                    var data = this.addPkgForm;
                    data.iccid = this.cardInfo.iccid
                    addPkg(data).then(res => {
                        if(res.data.code == 200){
                            this.$message.success(res.data.message);
                            this.addPkgVisible = false;
                            this.getSimDetailInfoHandler(this.cardInfo.iccid);
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })                    
                }
            })
        },
        stopSimHandler(){
            this.$confirm("您确定要进行停机操作吗？", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then( () => {
                var data = {
                    iccid: this.cardInfo.iccid
                }
                stopSim(data).then( res => {
                    if(res.data.code === '200'){
                        this.$message.success("停机完成！");
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    }else{
                        if(res.data){
                            this.$message.error(res.data.message);
                        }
                    }                    
                })
            })
        },
        resetSimHandler(){
            this.$confirm("您确定要进行复机操作吗？", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then( () => {
                var data = {
                    iccid: this.cardInfo.iccid
                }
                resetSim(data).then( res => {
                    if(res.data.code === '200'){
                        this.$message.success("复机完成！")
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);
                    }else{
                        this.$message.error(res.data.message)
                    }                    
                })
            })
        },
        simDiagnosisHandler(){
            this.$confirm("您确定使用一键诊断功能吗？", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then( () => {
                var data = {
                    iccid: this.cardInfo.iccid
                }
                simDiagnosis(data).then( res => {
                    if(res.data.code == 200){
                        this.$message.success("诊断完成！");
                        this.getSimDetailInfoHandler(this.cardInfo.iccid);  
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            })
        },

        sureAddOverlayPkg(){
            this.$refs.overlayPkgForm.validate(valid => {
                if(valid){
                    var data = this.overlayPkgForm;
                    data.iccid = this.cardInfo.iccid
                    addPkg(data).then(res => {
                        if(res.data.code == 200){
                            this.$message.success(res.data.message);
                            this.overlayPkgVisible = false;
                            this.getSimDetailInfoHandler(this.cardInfo.iccid);
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })                    
                }
            })            
        },

        isExpiredTime(str){
            let d = new Date(str);
            if(d<new Date()){
                return true;
            } 
            return false;
        },  
        showAddRealNameSearch(){//点击电信实名查询
            let data = {
                iccid: this.cardDetailsForm.iccid,
                intoNo:this.cardInfo.intoNo
            }
            getRealName(data).then(res => {
                if(res.data.code == 200){
                    this.$alert('已实名', {
                    confirmButtonText: '确定'})
                }else{
                    this.$alert('未实名', {
                    confirmButtonText: '确定'})
                }
            })
        },

        noBIndSIm(){            
            common.sysRequest("external/ctcc/no/bind", {iccid: this.cardInfo.iccid}, 'post').then(res => {
                 if(res.data.code === '200'){
                    this.$message.success('解绑成功！');
                 }else{
                     this.$message.error(res.data.message);
                 }

            })            
        },
        //跳转至【流量轮询详情】页面
        toFluxPollDetail(iccid){
            localStorage.setItem('pkGIccid',iccid);
            this.$store.commit('menu/setFluxPollDetailIccid', iccid);
            this.$store.commit('menu/setFluxPollDetailTaskNo', "");
            if (!this.$store.state.menu.isFluxPollDetailTab) {
                let newTab = {
                    label: '套餐详情',
                    index: 'fluxPollDetail',
                    closable: true,
                    component: "views/monitor/fluxPollDetail"
                }
                this.$store.commit('menu/addTab', newTab);
                this.$store.commit('menu/setIsFluxPollDetailTab', true);
            }
            this.$store.commit('menu/switchTab', 'fluxPollDetail')
        },
        handleSizeChange(val){
            this.pageSize = val;
            this.getOneSIMOrderListHandler();
        },
        handleCurrentChange(val){
            this.currentPage = val;
            this.getOneSIMOrderListHandler();
        },
        showOrderDetailHandler(row){//查看订单详情
            this.orderDetailVisible = true;
            this.orderDetailForm = row;
            return ; 
        },
        modifyOrderInfoHandler(row){//修改订单备注 
            if(row.remark.length == ''){
                return ;
            }
            let param = {
                id:row.id,
                remark:row.remark
            }
            modifyOrderRemark(param).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                    
                }else{
                    this.$message.error(res.data.message);
                }
            });

        },
        showAddOverlayPkg(){
            this.overlayPkgVisible = true;
            getOverlayPkgOptions({}).then(res => {
                if(res.data.code == 200){
                    this.overlayPkgGroup = res.data.data;
                }else{
                    this.$message.error(res.data.message)
                }
            })
        },
        changeHandler(){
            this.overlayPkgForm.packageId = '';
            var data = {
                typeGroupId: this.overlayPkgForm.typeGroupId
            }
            common.getPkgOfGroupCom(this, 'overlayPkgList', data);
        },
        IllusoryCardState(row){
            if(row.cardState >= 5 && row.cardState!=11){//异常或违禁
                if(row.cardState == 12){
                  return '注销'
                }else if(row.cardState == 9){
                  return '故障'
                }
                return '正常';
            }else{
                return row.cardStateName;
            }
        },
    }
}
</script>

<style lang="less" scoped>
.cerd{
    background:#fff;
    border-radius: 8px;
    padding:16px;
    margin-bottom:20px;
    .cerd-title{
        font-size: 16px;
        font-weight:bold;
        color:#242225;
        margin-bottom:12px;
    }
    .cerd-btn{
        .el-button{
            // padding: 12px 10px;
            margin-bottom:10px;
        }
    }
}
.total-page{
    height:192px;
    display: flex;
    margin-bottom:12px;
    .total-page-left{
        width:110px;
        margin-right: 15px;
        background: #F2F7FE;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .total-used{
            color:#6D6E73;
            font-size:14px;
            margin-bottom:4px;
        }
        .total-used-num{
            font-size: 20px;
            color:#242225;
            font-weight: bold;
        }
    }
    .total-page-right{
        width: calc(100% - 125px);
        border:1px solid #EEEEF0;
        .total-page-right-top{
            height:150px;
            display: flex;
            align-items: center;
            .progress{
                width:100px;
                text-align: center;
                position: relative;
                margin-left:10px;
               .el-progress{
                    ::v-deep .el-progress-circle{
                        width: 80px !important;
                        height: 80px !important;
                    }
                }
                .shengyu{
                    position: absolute;
                    top:26%;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    margin: auto;
                }
            }
            .total-dingdan{
                width:calc((100% - 100px) / 5);
                padding-left:60px;
            }
            .name{
                color:#6D6E73;
                font-size:14px;
            }
            .num{
                color:#222532;
                margin-top:4px;
                font-size:16px;
                font-weight:bold;
            }
        }
        .total-page-right-bottom{
            display: flex;
            padding-left:20px;
            border-top: 1px solid #F8F8FA;
            height:40px;
            align-items: center;
            div{
                padding-right:64px;
                color: #6D6E73;
                font-size:14px;
            }
        }
    }
}
.el-row {
    margin-bottom: 20px;
    &:last-child {
        margin-bottom: 0;
    }
}
.el-col {
    border-radius: 4px;
}
.bg-purple {
    background: #F2F7FE;
}
.grid-content {
    border-radius: 4px;
    min-height: 36px;
    padding:13px 20px;
    .name{
        color:#6D6E73;
        font-size: 14px;
        margin-bottom:5px;
    }
    .content{
        color:#222532;
        font-size:14px;
    }
}
</style>
